import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  searchIcon: {
    color: theme.palette.text.secondary
  }
}));
